import React, { useState } from "react";
import { api } from "../../lib/api";

const msg = (e) => e?.response?.data?.detail?.message || "That didn't work.";
const BTN = "min-h-[48px] px-4 rounded-sm text-sm font-semibold border border-erf-borderCream";

// Supervisor review (approve / return with comments) + revision review + photo capture for the report.
export function ReviewPanel({ r, onDone }) {
  const [c, setC] = useState("");
  const [err, setErr] = useState("");
  const act = (path) => api.post(path, { comment: c }).then(() => { setC(""); setErr(""); onDone(); }).catch((e) => setErr(msg(e)));
  const pending = (r.revisions || []).find((v) => v.state === "submitted");
  if (!r.can.review || (r.state !== "submitted" && !pending)) return null;
  const base = pending ? `/field/revisions/${pending.id}` : `/field/reports/${r.id}`;
  return (
    <section className="space-y-2 border border-erf-borderCream rounded bg-white p-3" data-testid="field-review">
      <h2 className="font-heading text-lg">{pending ? `Review revision ${pending.revision}: ${pending.reason}` : "Supervisor review"}</h2>
      <label className="text-xs block">Comments<textarea rows={3} className="w-full rounded border border-erf-borderCream p-2 text-base" value={c} onChange={(e) => setC(e.target.value)} data-testid="field-review-comment" /></label>
      {err && <p role="alert" className="text-sm text-red-700" data-testid="field-review-error">{err}</p>}
      <div className="flex flex-wrap gap-2">
        <button type="button" className={`${BTN} bg-erf-dark text-white`} onClick={() => act(`${base}/approve`)} data-testid="field-review-approve">Approve</button>
        <button type="button" className={BTN} onClick={() => act(`${base}/return`)} data-testid="field-review-return">Return with comments</button>
      </div>
    </section>
  );
}

export function PhotoCapture({ pid, reportId, online }) {
  const [note, setNote] = useState("");
  const up = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    api.post(`/phase4/photos/projects/${pid}`, f, { params: { daily_log_id: reportId, filename: f.name }, headers: { "Content-Type": f.type || "application/octet-stream" } })
      .then(() => setNote(`Photo "${f.name}" attached.`)).catch((x) => setNote(msg(x)));
    e.target.value = "";
  };
  if (!reportId) return <p className="text-xs" data-testid="field-photo-hint">Save the draft once to attach photos.</p>;
  return (
    <div className="space-y-1">
      <label className={`${BTN} inline-flex items-center cursor-pointer ${online ? "" : "opacity-50 pointer-events-none"}`}>
        Take / add photo
        <input type="file" accept="image/*" capture="environment" className="sr-only" disabled={!online} onChange={up} data-testid="field-photo-input" />
      </label>
      {!online && <p className="text-xs" data-testid="field-photo-offline">Photos need a connection (they are not queued offline).</p>}
      {note && <p role="status" className="text-xs" data-testid="field-photo-note">{note}</p>}
    </div>
  );
}
